export default __webpack_public_path__ + "static/media/sidebar-5.109ea1af.jpg";